// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Z5TRD","header":"MergedInvoice_header__2TzyG"};